import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  CanonicalTopicFilterBy,
  ClusterDomain,
  DataResponse,
  GetTopicActivityResponseDataSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetTopicActivityResponseDataSchema>>

type Props = {
  canonicalTopicId: string
  domain: ClusterDomain
  groupBy?: "day" | "week"
  filterBy?: CanonicalTopicFilterBy
  enabled?: boolean
}

export const canonicalTopicActivityQuery = ({
  canonicalTopicId,
  domain,
  groupBy = "day",
  filterBy,
  enabled = true,
}: Props) =>
  queryOptions({
    queryKey: ["canonical-topic-activity", canonicalTopicId, domain, groupBy, filterBy],
    queryFn: async () => {
      const response = await axios.get<Response>(
        `/insights/canonical-topics/${canonicalTopicId}/activity`,
        { params: { domain, groupBy, filterBy } },
      )
      return response.data.data
    },
    enabled: enabled && !!canonicalTopicId,
  })
